export const apiUnknownResponseError = () => {return {message:'API returned unexpected response'};};